import styled from 'styled-components';

export const TaskExpandActionsContainer = styled.div`
  margin-left: 14px;
  & > div {
    cursor: pointer;
  }
`;
